import { supabase } from './supabase';

/**
 * Tells the server to push-notify the operator(s) that a session was just
 * created on a platform Yhuu can't auto-send to (anything but WhatsApp) and
 * needs to be dispatched by hand from the Admin panel.
 *
 * Fire-and-forget: it must never slow down or break the sender's flow. The
 * send-push Edge Function decides everything server-side (is the session
 * really pending? was the admin already notified? who is the admin?) and
 * only ever notifies once per session, so calling this twice is harmless.
 */
export function notifyAdminOfPendingSession(testId: string) {
  supabase.functions
    .invoke('send-push', { body: { type: 'admin_dispatch_needed', testId } })
    .catch(() => {});
}
